import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderUIChatCommon = {
  key: 'uichat',
  authentication: ProviderAuthenticationCommon.Form(),
}

export type ProviderUIChatAccountType = null

export type UIChatAttachment = {
  uid: string
  lastModified: number
  lastModifiedDate: Date
  size: number
  type: string
  percent: number
  status: string
  name: string
  urlPrivate: string
}
